
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerEditor()
    export class IcStockAdjustInEditors extends Serenity.LookupEditorBase<Serenity.LookupEditorOptions, IcStockAdjustInRow>{

        constructor(hidden: JQuery) {
            super(hidden);
        }

        protected getLookupKey() {
            return IcStockAdjustInRow.lookupKey;
        }

        // protected getItemText(item, lookup) {
        //     return super.getItemText(item, lookup) + ' [' + item.MbFirstName+']';
        // }
    }
}
